export const MODULE_NAME = '@pressreader/purchase';
